import Vue from 'vue'
import VueRouter from 'vue-router'

import { hasPermission } from '@/utils/permissions'

import dashboard from './dashboard'
import budgetPlan from './budgetPlan'
import workOrder from './workOrder'
import logSheet from './logSheet'
import employee from './employee'
import company from './company'
import userRolePermission from './userRolePermission'
import contractor from './contractor'
import equipmentType from './equipmentType'
import summaryHM from './summaryHM'
import summaryProgress from './summaryProgress'
import backupPayment from './backupPayment'
import paymentAuth from './paymentAuth'
import summaryProgressDataSurvey from './summaryProgressDataSurvey'
import fuelPriceExhangeRate from './fuelPriceExhangeRate'
import SummaryVolumeCalculation from './summaryVolumeCalculation'
import SummaryResumeVolumeWork from './summaryResumeVolumeWork'
import overburden from './overburden'
import coalAuxiliary from './coalAuxiliary'
import other from './other'
import summaryBUP from './summaryBUP'
import approvalOnlineDoa from './approvalOnlineDoa'
import coalLoading from './coalLoading'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Home'),
    children: [
      {
        path: '',
        redirect: () => '/dashboard'
      },
      { ...dashboard },
      { ...budgetPlan },
      { ...workOrder },
      { ...logSheet },
      { ...employee },
      { ...company },
      { ...userRolePermission },
      { ...contractor },
      { ...equipmentType },
      { ...summaryHM },
      { ...summaryProgress },
      { ...backupPayment },
      { ...paymentAuth },
      { ...summaryProgressDataSurvey },
      { ...fuelPriceExhangeRate },
      { ...SummaryVolumeCalculation },
      { ...SummaryResumeVolumeWork },
      { ...overburden },
      { ...coalAuxiliary },
      { ...other },
      { ...summaryBUP },
      { ...approvalOnlineDoa },
      { ...coalLoading },
      {
        path: '403',
        name: 'Forbidden',
        component: () => import('@/views/403')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const NO_REDIRECTS = [
    '/login',
    '/dashboard',
    '/403'
  ]

  if (to.path !== '/login' && !localStorage.getItem('token')) {
    localStorage.setItem('route', to.fullPath)
    next('/login')
  } else if (
    !NO_REDIRECTS.includes(to.path) &&
    !hasPermission(to.meta.permission)
  ) {
    next('/403')
  } else {
    next()
  }
})

export default router
